module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollCon",
    staticClass: "tags-outer-scroll-con",
    on: {
      "mousewheel": _vm.handlescroll
    }
  }, [_c('div', {
    staticClass: "close-all-tag-con"
  }, [_c('Dropdown', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-click": _vm.handleTagsOption
    }
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n                标签选项\n                "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "clearAll"
    }
  }, [_vm._v("关闭所有")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "clearOthers"
    }
  }, [_vm._v("关闭其他")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "scrollBody",
    staticClass: "tags-inner-scroll-body",
    style: ({
      left: _vm.tagBodyLeft + 'px'
    })
  }, [_c('transition-group', {
    attrs: {
      "name": "taglist-moving-animation"
    }
  }, _vm._l((_vm.pageTagsList), function(item, index) {
    return _c('Tag', {
      key: item.name,
      ref: "tagsPageOpened",
      refInFor: true,
      attrs: {
        "type": "dot",
        "name": item.name,
        "closable": item.name !== 'home_index',
        "color": item.children ? (item.children[0].name === _vm.currentPageName ? 'blue' : 'default') : (item.name === _vm.currentPageName ? 'blue' : 'default')
      },
      on: {
        "on-close": _vm.closePage
      },
      nativeOn: {
        "click": function($event) {
          return _vm.linkTo(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.itemTitle(item)))])
  }), 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a1a0903e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1a0903e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/views/main_components/tagsPageOpened.vue
// module id = 1372
// module chunks = 61